



































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { orderBy } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { SortOrder } from '@/types'

export interface SearchHistoryTableItem {
  id: number
  isSelected: boolean
  searchType: string
  item1: string
  key1: string
  item2: string
  key2: string
}

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'searchType',
        headerText: '検索種別',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'item1',
        headerText: '項目１',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'key1',
        headerText: 'キー１',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'item2',
        headerText: '項目２',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'key2',
        headerText: 'キー２',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

interface SearchItemName {
  searchTarget: string
  title1: string
  title2: string
  titleInformation: string
  author1: string
  author1Id: string
  author2: string
  author2Id: string
  authorInformation: string
  subject1: string
  subject1Id: string
  subject2: string
  subject2Id: string
  series: string
  seriesId: string
  completeWorks: string
  completeWorksId: string
  notes: string
  contentTitle: string
  contentAuthor: string
  contentAuthorId: string
  publisher: string
  publisherId: string
  volumeLabel: string
  classNo: string
  publishedYearFrom: string
  publishedYearTo: string
  playbackTimeFrom: string
  playbackTimeTo: string
  volume: string
  volumeNumber: string
  volumeTotal: string
  dateLabel: string
  genre: string
  targetUsers: string
  targetUsersAv: string
  collectionType: string
  shelfType: string
  mark: string
  ndc: string
  book: string
  sub: string
  traderCode: string
  donorCode: string
  collectionStatus: string
  holdingBranchCode: string
  acceptDateFrom: string
  acceptDateTo: string
  handlingType: string
  lendTotal: string
  lastLendDate: string
  searchType: string
  collectionTarget: string
  materialFormat: string
  newPublicationInformationDate: string
  newPublicationInformationVolume: string
  collectionNo: string
  exceptCheckDigit: string
  orderId: string
  bibliographyId: string
  isbn: string
  productNo: string
  magazineCode: string
  marcNo: string
  freeWords: string
}

const SEARCH_ITEM_NAME: SearchItemName = {
  searchTarget: '検索対象',
  title1: 'タイトル０１',
  title2: 'タイトル０２',
  titleInformation: 'タイトル',
  author1: '責任表示０１',
  author1Id: '責任表示０１ID',
  author2: '責任表示０２',
  author2Id: '責任表示０２ID',
  authorInformation: '責任表示',
  subject1: '件名０１',
  subject1Id: '件名０１ID',
  subject2: '件名０２',
  subject2Id: '件名０２ID',
  series: 'シリーズ',
  seriesId: 'シリーズID',
  completeWorks: '全集',
  completeWorksId: '全集ID',
  notes: '注記',
  contentTitle: '内容タイトル',
  contentAuthor: '内容責任表示',
  contentAuthorId: '内容責任表示ID',
  publisher: '出版者',
  publisherId: '出版者ID',
  volumeLabel: '巻次',
  classNo: '分類番号',
  publishedYearFrom: '刊年From',
  publishedYearTo: '刊年To',
  playbackTimeFrom: '再生時間From',
  playbackTimeTo: '再生時間To',
  volume: '巻',
  volumeNumber: '号',
  volumeTotal: '通巻号',
  dateLabel: '年月日号',
  genre: 'ジャンル',
  targetUsers: '利用対象（図書、雑誌）',
  targetUsersAv: '利用対象（AV）',
  collectionType: '資料区分',
  shelfType: '配架区分',
  mark: '別置記号',
  ndc: '請求分類',
  book: '図書記号',
  sub: '補助記号',
  traderCode: '業者コード',
  donorCode: '寄贈者コード',
  collectionStatus: '資料状態',
  holdingBranchCode: '所蔵館コード',
  acceptDateFrom: '受入日From',
  acceptDateTo: '受入日To',
  handlingType: '取扱区分',
  lendTotal: '貸出回数',
  lastLendDate: '最終貸出日',
  searchType: '検索区分',
  collectionTarget: '所蔵発注選定対象',
  materialFormat: '資料形態',
  newPublicationInformationDate: '新刊案内日',
  newPublicationInformationVolume: '新刊案内号',
  collectionNo: '資料番号',
  exceptCheckDigit: '資料番号CD',
  orderId: '発注番号',
  bibliographyId: '書誌番号',
  isbn: 'ISBN等',
  productNo: '品番',
  magazineCode: '雑誌コード',
  marcNo: 'MARC区分',
  freeWords: 'フリーワード'
}

interface SearchKeyName {
  displayMethod: {
    '1': string
    '2': string
    '3': string
  }
  searchTarget: {
    '1': string
    '2': string
    '3': string
  }
  numberOfLimit: {
    1000: string
    3000: string
    5000: string
    9999: string
  }
  lendTotalFlag: {
    1: string
    2: string
  }
  collectionTarget: {
    1: string
    2: string
    3: string
  }
}

const SEARCH_KEY_NAME = {
  displayMethod: {
    '1': '簡易一覧',
    '2': '詳細一覧',
    '3': '書影あり詳細一覧'
  },
  searchTarget: {
    '1': 'ＤＢのみ',
    '2': 'ＴＯＯＬｉのみ',
    '3': 'ＴＯＯＬｉ'
  },
  numberOfLimit: {
    1000: '1000件',
    3000: '3000件',
    5000: '5000件',
    9999: '9999件'
  },
  lendTotalFlag: {
    1: '未満',
    2: '以上'
  },
  collectionTarget: {
    1: '所蔵',
    2: '発注',
    3: '選定'
  }
}

interface SearchTypeName {
  '1': string
  '2': string
  '3': string
  '4': string
  '5': string
}

const SEARCH_TYPE_NAME: SearchTypeName = {
  '1': '基本検索',
  '2': '単独検索',
  '3': 'フリーワード検索',
  '4': '典拠検索',
  '5': '内容検索'
}

@Component({
  components: { DataTable }
})
export default class SearchHistoryTable extends ComponentVue {
  @PropSync('tableItems', {
    type: Array
  })
  items!: SearchHistoryTableItem[]

  @Prop({
    type: Number
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return COLS
  }

  get sortedItems(): SearchHistoryTableItem[] {
    if (this.sortName) {
      return orderBy<SearchHistoryTableItem>(
        this.items,
        (item: SearchHistoryTableItem) => {
          const propertyValue =
            item[this.sortName as keyof SearchHistoryTableItem]

          if (this.sortName === 'searchType') {
            return this.searchTypeName(propertyValue as string)
          }
          if (['item1', 'item2'].includes(this.sortName)) {
            return this.searchItemName(propertyValue as string)
          }
          if (this.sortName === 'key1') {
            return this.searchKeyName(item.item1, item.key1)
          }
          if (this.sortName === 'key2') {
            return this.searchKeyName(item.item2, item.key2)
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }
    return this.items
  }

  mounted() {
    this.onSort({
      name: '',
      order: ''
    })
  }

  onClickRow(index: number) {
    if (this.sortedItems[index].isSelected) return

    this.items.some(item => {
      if (item.id === this.sortedItems[index].id) {
        item.isSelected = true
        return false
      }
      item.isSelected = false
    })
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  searchTypeName(value: string): string {
    if (['1', '2', '3', '4', '5'].includes(value)) {
      const key: keyof SearchTypeName = value as '1' | '2' | '3' | '4' | '5'
      return SEARCH_TYPE_NAME[key]
    }

    return ''
  }

  searchItemName(item: string): string {
    if (SEARCH_ITEM_NAME.hasOwnProperty(item)) {
      const key: keyof SearchItemName = item as keyof SearchItemName
      return SEARCH_ITEM_NAME[key]
    }

    return ''
  }

  searchKeyName(item: string, key: string | number): string {
    if (SEARCH_KEY_NAME.hasOwnProperty(item)) {
      const propertyKey: keyof SearchKeyName = item as keyof SearchKeyName
      const property: any = SEARCH_KEY_NAME[propertyKey]
      return property[key]
    }

    return String(key)
  }
}
